export default {
  header: {
    close: 'Close',
    startsAt: 'Starts: {{startDate}}',
    firstTeeTimeTbd: 'First Tee Time (TBD)',
    entriesAnon: 'Entries',
    entries: 'Entries: {{filled}}/{{max}}',
    entry: 'Entry',
    prizes: 'Prizes',
  },
  slatesNav: {
    slateDate: {
      tomorrow: 'Tomorrow {{formattedDate}}',
      today: 'Today {{formattedDate}}',
    },
    segment: 'Segment {{index}}',
  },
  pickHistory: {
    title: 'Pick history',
    status: {
      live: 'LIVE',
      final: 'FINAL',
    },
    table: {
      tournament: 'TOURNAMENT',
      picks: 'PICK/PICKS',
      position: 'POS',
      strokes: 'SCORE',
      earnings: 'EARNINGS',
    },
    emptySegment: 'No picks available for this segment',
    emptyEntry: 'No picks available for this entry',
    viewPicks: 'View picks',
  },
  picksBar: {
    submitLabelDefault: 'Save picks',
    submitLabelLosing: 'Save losing picks',
    submitting: 'Saving...',
    depositToSubmit: 'Deposit to save picks',
    picksMade: '{{picksMade}}/{{requiredPicksCount}} picks made',
    signInToSubmit: 'Log in to save picks',
    createNewEntry: 'Create entry: {{entryFee}}',
    createNewEntryEntertainmentOnly: 'Create entry',
    cancel: 'Cancel',
  },
  common: {
    marketplaceBanner: {
      buyAndSell: 'Buy and sell live entries',
      offers__hasPlural: {
        one: 'You have {{count}} offer for your entries',
        other: 'You have {{count}} offers for your entries',
      },
    },
    makePicks__hasPlural: {
      one: 'Make pick',
      other: 'Make picks',
    },
    // Read-only viewers can't act on a missing pick, so they get neutral copy instead of the controller's "Make pick" nudge.
    noPicks__hasPlural: {
      one: 'No pick',
      other: 'No picks',
    },
    pickSelected__hasPlural: {
      one: 'Pick Selected',
      other: 'Picks Selected',
    },
    makePicksUniversal: 'Make your pick(s)',
    autoPickBanner: {
      applied: 'Auto-pick applied <bold>{{slateName}}</bold>',
    },
    autoPickToast: {
      content: '<bold>Auto-pick:</bold> {{strategyLabel}}',
      editSettings: 'Edit autopick settings',
    },
    banners: {
      entryRevived: 'Entry revived',
      autoPicksApplied: 'Auto-picks applied',
      revivedWithAutoPicks: 'Auto-picks applied • Entry revived',
    },
    editPicks__hasPlural: {
      one: 'Edit pick',
      other: 'Edit picks',
    },
    yourPicks__hasPlural: {
      one: 'Your pick',
      other: 'Your picks',
    },
    entryDetails: 'Entry details',
    picksheetNotReady: 'Picksheet not yet available',
    action: {
      dismiss: 'Dismiss',
    },
    errorSubmittingPicks: {
      title: 'There was an error while saving your picks.',
      defaultMessage: 'Unknown error',
    },
    entriesScheduled: {
      myEntries: 'My entries',
      entries: 'Entries',
      entryFee: 'Entry',
      maxEntries: 'Max',
    },
    entryOwnership: {
      boughtOnMarketplace: 'This entry was bought on',
      youOwn: 'You own',
      pickControl: 'Pick control',
      pickControlYes: 'Yes',
      pickControlNo: 'No',
      viewEntry: 'View entry on Marketplace',
      close: 'Close',
      you: 'You',
      originalOwner: 'Original owner',
      makesPicks: 'Makes picks',
    },
    entryName: {
      groupEntry: 'Group Entry',
      groupEntryWith: 'Group entry with {{handle}}',
      partialEntry: 'Partial Entry',
    },
    entryScheduled: {
      edit: 'Edit',
      editPicks: 'Edit picks',
      withdraw: 'Withdraw',
      groupEntryWith: 'Group entry with {{handle}}',
      groupEntry: 'Group entry',
    },
    unknownUser: 'Unknown User',
    entryDetail: {
      title: 'Entry details',
      noPicksVisibleYet:
        'No picks are visible yet. All picks will be visible once the picks will be locked for this slate.',
      noPicks: 'This entry has no picks for this slate.',
      slateSublabel: {
        final: 'FINAL',
        live: 'LIVE',
      },
    },
    standings: {
      winLoss: 'W-L',
      points: 'Points',
      empty: {
        beforeStart: 'The entries for this slate will be visible after the slate start',
        afterStart: 'There are no entries for this slate',
      },
      overall: 'Overall',
      segments: 'Segments',
      bySlateDefault: 'Slate',
      segmentItem: 'Segment {{index}}',
      pointsAbbr: 'Pts',
      potentialPointsAbbr: 'Potential',
      entry: {
        errorLoadingDetails: 'Error loading details',
        retry: 'Retry',
      },
      viewFullPickHistory: 'View full pick history',
      noBreakdownData: 'No breakdown data available',
      playerTitle: 'PLAYER',
      emptyState: {
        title: "Oops, you're early!",
        description: 'Standings for this {{slateLabel}} will be available once it starts.',
      },
      noSearchResults: {
        title: 'No such players found',
      },
      filters: {
        viewAllTitle: 'View all',
        options: {
          all: 'All',
          followingOnly: 'Players you follow',
        },
      },
      tiebreakerHeader: 'Championship Tiebreaker',
      tiebreakerHeaderMobile: 'Tiebreaker',
      tiebreakerLabel: 'Tiebreaker',
      tiebreakerDiff: 'Diff {{diff}}',
      tiebreakerDiffColon: 'Diff: {{diff}}',
      tiebreakerDiffLabel: 'Diff',
    },
    slatesNav: {
      points__hasPlural: {
        one: '{{count}} point',
        other: '{{count}} points',
      },
    },
    availability: {
      nav: {
        available: 'Available',
        unavailable: 'Unavailable',
      },
      entry: {
        viewAll: 'View all',
        noTeams: 'No teams',
        noPlayers: 'No players',
      },
      banner: {
        updatesNotFinal: 'Updates when current {{slateLabel}} is final',
        contestFinal:
          'This contest is finalized. The availability tab shows data from the last {{slateLabel}}.',
        playerTierSlateNotGenerated: 'Updates when next {{slateLabel}}’s player pool is generated',
        playerTierSlateFinal: 'Updates when current {{slateLabel}} is final',
      },
      entryDetail: {
        available: {
          subtitle: 'Availability for {{slateName}}',
        },
        unavailable: {
          title: 'Unavailable {{items}}: {{entryName}}',
        },
      },
      report: {
        banner: {
          title: 'Availability for:',
          button: 'View availability report',
        },
        title: 'Availability report',
        tableHead: {
          team: 'Team',
          player: 'Player',
          available: 'Available this {{slateLabel}}',
        },
        noData: 'No data',
      },
      metrics: {
        projectedFantasyPoints: 'PROJ: {{value}}',
        datagolf_rank: 'Rank: {{value}}',
        world_rank: 'Rank: {{value}}',
        unknown: '{{value}}',
      },
      pickCount: 'Picked: {{pickCount}}/{{picksReuseLimit}}',
      team: {
        pickedCount: 'Picked: {{picked}}/{{total}}',
      },
      filter: {
        trigger: 'Filter by teams',
        triggerCount: 'Filter by teams ({{count}})',
        searchPlaceholder: 'Search teams',
        noMatches: 'No teams match',
        close: 'Close filter',
        clear: 'Clear',
        apply: 'Apply',
        atCap: 'You can filter on up to {{count}} teams at once',
        pillsLabel: {
          available: 'Available',
          unavailable: 'Unavailable',
        },
        removeTeam: 'Remove {{team}} from {{filter}} filter',
        entriesFound__hasPlural: {
          one: '{{count}} entry found',
          other: '{{count}} entries found',
        },
        noMatchingEntries: 'No entries match these teams',
      },
    },
    accessError: {
      actions: {
        viewMyEntries: 'View my entries',
        backToHome: 'Back to home',
      },
      maxEntriesReached: {
        title: 'Max entries reached',
        description: 'You have reached the maximum number of entries for this contest',
      },
      invalidEntry: {
        title: 'Invalid entry',
        description: 'You have followed an invalid link',
      },
      unauthViewingNonFirstSlate: {
        title: 'Slate unavailable',
        description:
          'You need to sign in to view other slates. Please sign in or go to the first slate.',
        signIn: 'Sign in',
        goToFirstSlate: 'View the first slate',
      },
    },
    notification: {
      noChanges: 'You have not made any changes to your picks.',
    },
    picksHeader: {
      headerMenu: {
        withdraw: 'Withdraw',
        tutorial: 'Tutorial',
      },
    },
    entrants: {
      raf: {
        copy: 'Share this contest',
        banner: 'Refer a friend and earn rewards',
      },
      list: {
        noEntrants: 'No entrants yet',
        error: 'There was an issue while loading entries',
        retry: 'Try again',
        errorSubtitle: 'Please try again later',
        following: 'Following',
        followsYou: 'Follows you',
        mutuallyFollowing: 'Mutually following',
        action: 'Follow',
        unfollow: 'Unfollow',
      },
    },
    tooltip: {
      autopick: {
        title: 'Auto-picks',
        description:
          'A predetermined team selection that gets submitted when an entrant fails to make a manual pick before the deadline.',
      },
      entryRevival: {
        title: 'Entry revival',
        description: 'This entry was revived after previously being eliminated.',
      },
    },
  },
  team: {
    pickGoalBanner: {
      title: 'You selected {{teamName}} to <bold>lose</bold>.',
    },
    bye: '(BYE)',
    pointsInfo: {
      points: 'Points:',
      potentialPoints: 'Potential points:',
    },
    game: {
      footer: {
        bestPick: 'Best pick',
        confidenceScore: 'Confidence points:',
      },
      header: {
        finalized: {
          title: 'FINAL',
        },
        live: {
          title: 'LIVE',
        },
        scheduled: {
          preview: 'Preview',
        },
        missedPick: 'Missed pick',
      },
      team: {
        alreadyPicked: 'Already picked',
        advanceProbablity: 'Advance prob: {{advanceProbablity}}%',
        winProbablity: 'Win prob: {{winProbablity}}%',
        loseProbablity: 'Lose prob: {{loseProbablity}}%',
        pickedCount: 'Picked: {{picked}}/{{total}}',
      },
    },
    picksList: {
      sortBy: {
        startDate: 'Start Time',
        seed: 'Seed',
      },
      groupStage: {
        title__hasPlural: {
          one: 'Select {{count}} team to advance',
          other: 'Select {{count}} teams to advance',
        },
        picksDeadlineLabel: 'Start of the first game',
      },
    },
    picksheetNotAvailableYet: {
      title: "You're early",
      subtitle: 'This pick sheet is not yet available.<br></br>Check again later.',
    },
    notification: {
      picksLimitMet:
        "You have all of your picks made for this slate. If you'd like to change your picks you must remove them.",
      pickTeamBeforeBestPick: 'You must select a team before setting it as your best pick.',
      groupPicksLimitMet: 'You can only make {{maxPicksPerGroup}} picks in this group.',
    },
    pickEm: {
      picksBar: {
        close: 'Close',
        gameStatus: {
          cancelled: 'Cancelled',
          final: 'Final',
          inProgress: 'Live',
        },
        noPick: 'No pick',
        missedPick: 'Missed pick',
      },
      entryOverall: {
        week: 'Week',
        segment: 'Segment',
        winLoss: 'W-L',
        points: 'Points',
      },
      stats: {
        notAvailable: {
          title: 'Week not started',
          description: {
            game: 'The stats tab will populate as each game starts.',
            slate: 'The stats tab will populate after the pick deadline.',
          },
        },
      },
    },
    survivor: {
      pickGoalBanner: {
        title: 'Select a team to <bold>{{actionText}}</bold>',
      },
      standings: {
        entries: {
          actions: {
            revive: 'Revive entry',
          },
          tiebreakers: {
            seedTotal: 'Seed total:',
            winMargin: 'Win Margin:',
          },
        },
      },
      stats: {
        subNav: {
          slateSummary: '{{slateLabel}} summary',
          availability: 'Team availability',
        },
        summaryLabels: {
          survivors: 'Survivors',
          eliminated: 'Eliminated',
          missedPick: 'Missed pick',
          autoPicksApplied: 'Auto-picks applied',
          entriesRevived: 'Entries revived',
        },
        notAvailable: {
          title: '{{slateLabel}} not started',
          description: {
            game: 'The stats tab will populate as each game starts.',
            slate: 'The stats tab will populate after the pick deadline.',
            common:
              'To see the teams available for each entry and the number of entries that can select each team for the upcoming week, go to the <link>Availability tab</link>.',
          },
        },
        overallStats: {
          banner: {
            title: 'Overall stats',
            link: 'View',
          },
          modal: {
            title: 'Overall contest stats',
            totalEntries: 'Total entries:',
            totalSurviving: 'Total surviving',
            totalEliminated: 'Total eliminated',
            survivingWithLives__hasPlural: {
              one: 'Surviving with {{count}} life',
              other: 'Surviving with {{count}} lives',
            },
            entries__hasPlural: {
              one: 'entry',
              other: 'entries',
            },
          },
        },
        teamSlateStats: {
          title: 'Team selection details',
          entrants: 'The following entrants have selected this team in your contest.',
          noEntries: 'No entries selected this team',
        },
        combos: {
          viewToggle: {
            label: 'Stats view',
            combos: 'Combos',
            teams: 'Teams',
          },
          list: {
            combo: 'Combo',
            showMore: 'Show more',
            loadMoreError: 'Something went wrong loading combos.',
            retry: 'Try again',
          },
          row: {
            label: '{{teams}}, {{percentage}}, {{entries}}',
            labelWithStatus: '{{teams}}, {{percentage}}, {{entries}}, {{status}}',
            percentageBelowMinimum: '<0.1%',
            percentageBelowMinimumLabel: 'less than 0.1%',
            entries__hasPlural: {
              one: '{{formattedCount}} entry',
              other: '{{formattedCount}} entries',
            },
            status: {
              won: 'Won',
              lost: 'Lost',
              inProgress: 'In progress',
            },
          },
          empty: {
            title: 'No combos to show yet',
            description:
              'A combo appears once all of its games have started or the pick deadline has passed.',
          },
          comboSlateStats: {
            title: 'Combo selection details',
            entrants: 'The following entrants have selected this combo in your contest.',
          },
        },
      },
    },
    stats: {
      notAvailable: {
        slateSummary:
          '{{slateLabel}} pick summaries are not available until after the first game of the week has started or the weekly pick deadline has passed',
        availability: 'Available teams will show once the previous week is finalized',
        viewEntries: 'View Entries',
      },
      listColumns: {
        pickedPercentage: '%Picked',
        pickedCount: '#Picked',
        availableCount: 'Available this slate',
        confidenceAverage: 'Avg Pts',
      },
      summaryValueLabels: {
        entries: 'Entries',
        percentage: 'Percentage',
      },
      pickDeadlineBanner: {
        game: 'Games will appear after they start',
        slate: 'All games will appear after the pick deadline',
      },
    },
    leadeboardWidget: {
      myEntries: 'My Entries:',
      mySurvivors: 'My entries alive:',
      entered: 'Entered:',
      entry: 'Entry:',
      won: 'Won:',
      winning: 'Winning:',
      suvivors: 'Alive:',
      tooltip__hasPlural: {
        one: 'Entry {{index}}: {{count}} pt',
        other: 'Entry {{index}}: {{count}} pts',
      },
    },
    gameStats: {
      leagueNotSupported: 'Matchup screen not available for this league',
      odds: {
        title: 'Odds',
        attributes: {
          spread: 'Spread',
          moneyline: 'Moneyline',
          win_probability: 'Implied win probability',
        },
      },
      overview: {
        title: {
          nfl: 'Matchup',
          ncaab: 'Regular season stats',
          ncaaf: 'Matchup',
        },
        attributes: {
          ppg: 'Points per game',
          pa: 'Points against',
          fieldGoalPercentage: 'Field Goal %',
          reboundsPerGame: 'Rebounds per game',
          assistsPerGame: 'Assists per game',
          blocksPerGame: 'Blocks per game',
          stealsPerGame: 'Steals per game',
        },
      },
      injuries: {
        title: 'Injuries',
        status: {
          Questionable: 'Quest',
          Doubtful: 'Doub',
          Out: 'Out',
        },
      },
      stats: {
        lastGames_title: 'Last {{ count }} games',
        lastMeetings_title: 'Last {{ count }} meetings',
        win: 'W',
        lose: 'L',
      },
      soccer: {
        stats: {
          title: 'Stats',
          attributes: {
            goalsScoredPerMatch: 'Goals scored per match',
            goalsConcededPerMatch: 'Goals conceded per match',
            ballPossessionPercentage: 'Ball possession %',
            totalShotsPerMatch: 'Total shots per match',
            totalShotsOnTargetPerMatch: 'Total shots on target per match',
            cornersPerMatch: 'Corners per match',
            interceptionsPerMatch: 'Interceptions per match',
          },
        },
      },
    },
    accessError: {
      actions: {
        viewMyEntries: 'View my entries',
        backToHome: 'Back to home',
      },
      maxEntriesReached: {
        title: 'Max entries reached',
        description: 'You have reached the maximum number of entries for this contest',
      },
      invalidEntry: {
        title: 'Invalid entry',
        description: 'You have followed an invalid link',
      },
    },
    entryDetail: {
      noPicksVisibleYet:
        'No picks are visible yet. All picks will be visible once the picks will be locked for this slate.',
      noPicks: 'This entry has no picks for this slate.',
      slateSublabel: {
        final: 'FINAL',
        live: 'LIVE',
      },
    },
  },
  player: {
    common: {
      entryScheduled: {
        missingPicks: 'Undrafted lineup',
        playerPoolNotReady: 'Player pool not yet available',
        injuredPlayer: 'Entry with injuries',
      },
      selectPlayer__hasPlural: {
        one: 'Select player',
        other: 'Select players',
      },
      dropWorstCount__hasPlural: {
        one: 'Worst player score is being dropped',
        other: '{{count}} worst player scores are being dropped',
      },
      playerCard: {
        upcomingPlaceholder: 'shown on game start',
        emptyPick: 'Select',
        dropWorstNth__hasPlural: {
          one: 'Worst',
          other: '{{ordinal}} worst',
        },
      },
      playerPoolNotReady: {
        title: 'Players not available',
        subtitle:
          'You will be able to make your selection(s) for this slate once the player pool is determined.',
        action: 'View scheduled games',
        backAction: 'Go back',
      },
      upcomingSlate: 'Upcoming',
      gamesCount: '{{count}} games',
      slateBanner: {
        players: 'Players',
        viewTeeTimes: 'View tee times',
        points__hasPlural: {
          one: '{{count}}pt',
          other: '{{count}}pts',
        },
      },
      teeTimesModal: {
        title: 'Tee times',
        tableHead: {
          player: 'Player',
          teeTime: 'Tee time',
        },
        emptyState: {
          title: 'Not available yet',
          description: 'Tee times for {{slateName}} will be available prior to the start.',
        },
      },
      playerPoolSearch: {
        placeholder: 'Search players',
      },
      playerPoolList: {
        noSearchResults: {
          title: 'No players found',
          subtitle: 'Try another search.',
        },
        noSearchResultsNoFilter: {
          title: 'No players available',
          subtitle: 'There are no players available to select based on the game filters applied.',
        },
      },
      submit: {
        success: 'Your Lineup has been submitted.',
        error: 'Your Lineup has not been submitted. Please try again.',
      },
      entryDetail: {
        undraftedLineup: {
          title: 'No lineup submitted',
          button: 'Draft lineup',
        },
      },
      playerPool: {
        locked: {
          currentPick: "This player is locked. Your pick's competition has started",
          otherPick: 'This player is locked. Their competition has started',
        },
        maxPicked__hasPlural: {
          one: 'You’ve already selected this player once. You cannot select them again',
          two: 'You’ve already selected this player twice. You cannot select them again',
          other:
            'You’ve already selected this player {{count}} times. You cannot select them again',
        },
        cannotPick: 'This player is not selectable',
      },
      playerDetail: {
        actions: {
          draft: 'Draft',
          remove: 'Remove player',
          swap: 'Swap player',
          selectAlternate: 'Select alt',
          select: 'Select',
        },
      },
      playersPage: {
        filters: {
          onlyShowMyPlayers: 'Only show my players',
          sortBy: 'Sort by',
          positions: 'Positions',
          viewType: 'View type',
          viewTypeLabel: 'View as: ',
        },
        viewType: {
          cards: 'Cards',
          table: 'Table',
        },
        noPlayers: {
          title: 'No players',
          subtitle: {
            default: 'Players will show once their competition starts',
            withFilters: 'No players found with the selected filters',
          },
        },
        tableHeader: {
          player: 'Player',
          position: 'Pos',
          score: 'Score',
          earnings: 'Earnings',
          picked: 'Picked',
          picks: 'Picks',
          roundScores: 'Round scores',
        },
      },
      playerPicksModal: {
        title: 'Player selection details',
        description__hasPlural: {
          one: 'The following entrant has selected this player.',
          other: 'The following entrants have selected this player.',
        },
        close: 'Close',
        playerLabel: 'PLAYER',
        pickedLabel: 'PICKED',
        picksLabel: 'PICKS',
        emptyState: 'No entrants have picked this player yet.',
      },
    },
    tier: {
      entryActions: {
        clear: 'Clear',
        submit: 'Save lineup',
      },
      picksCountBanner: {
        picksCount: '{{picksCount}}/{{expectedPicksCount}} players drafted',
      },
      standings: {
        overall: {
          labels: {
            earnings: 'EARNINGS',
            fpts: 'FPTS',
            score: 'SCORE',
          },
        },
      },
    },
    oneAndDone: {
      standings: {
        tableHeader: {
          rank: '#',
          player: 'PLAYER',
          picks: 'PICK/PICKS',
          pos: 'POS',
          stroke: 'SCORE',
          totalStrokes: 'TOTAL SCORE',
          earnings: 'EARNINGS',
        },
        searchPlaceholder: 'Search entrants',
        ariaLabel: 'Golf standings by tournament',
        emptyState: {
          title: 'No standings yet',
          subtitle: 'No standings are available for this {{slateLabel}} yet.',
        },
      },
    },
    survivor: {
      scheduledGamesModal: {
        title: 'Scheduled Games',
        titleWithSlate: '{{slateName}} - Scheduled Games',
        noGames: 'No games scheduled for this slate.',
      },
      slate: {
        nav: {
          final: 'Final',
        },
      },
      pool: {
        noPicksSubmitted: {
          title: 'No picks submitted',
          subtitle: 'The pick deadline for this slate has passed.',
        },
        picksForOtherEntrants: {
          title: "You're early",
          subtitle: 'Picks for other entrants will show up once the day starts.',
        },
        picks: {
          alternate: {
            title: 'Alternates',
            description:
              'Alternates replace inactive primary players. The swap occurs after the completion of all games on the day.',
          },
          inactive: {
            title: 'Inactive',
            description: 'Replaced by alternate because player did not play.',
          },
          placeholder: {
            title: 'Player shown on game start',
          },
        },
      },
      stats: {
        notAvailable: {
          title: 'No players to show',
          description: {
            game: 'The stats tab will populate as each player starts.',
            common:
              'To see the players available for each entry and the number of entries that can select each player for the upcoming day, go to the <link>Availability tab</link>.',
          },
        },
        summaryLabels: {
          survivors: 'Survivors',
          eliminated: 'Eliminated',
          missedPick: 'Missed pick',
        },
        playerSlateStats: {
          title: 'Player selection details',
          entrants: 'The following entrants have selected this player in your contest.',
        },
      },
    },
    playerSurvivor: {
      picksList: {
        entryEliminated: {
          title: 'Entry eliminated',
          subtitle: 'This entry was eliminated on {{slateName}}',
        },
        entryWon: {
          myTitle: 'You won',
          otherTitle: 'Winner',
          subtitle: 'This entry won on {{slateName}}',
        },
        ableToMakePicks: {
          title: 'No picks submitted',
          subtitle: 'You have not submitted any picks. Make your picks before it is too late.',
          button: 'Make picks',
          editPicksButton: 'Edit picks',
        },
        scoredPicksNote__hasPlural: {
          one: 'On {{slateName}}, only {{requiredCorrectPicks}} primary player needs to hit their stat for your entry to advance.',
          other:
            'On {{slateName}}, only {{requiredCorrectPicks}} primary players need to hit their stat for your entry to advance.',
        },
      },
      picksChangedAlert: {
        title: 'Your selections have been removed',
        text: 'This player is no longer available and has been removed. You will need to make another selection and re-submit your picks.',
        removed: 'Removed',
        submit: 'Make another selection',
      },
    },
  },
  oneAndDone: {
    standings: {
      allPlayersSortedByRank: 'All players sorted by rank',
      playersSortedByRank: 'Players sorted by rank',
    },
  },
  spreadDeadlineBar: {
    lock: 'Spread locks: {{date}}',
    finalized: 'Spread finalized',
  },
  picksDeadlineBar: 'Picks lock: {{label}}',
  makeYourPicksBar: 'Make your picks',
  modal: {
    discardChangesModal: {
      title: 'Unsaved picks',
      description: 'You have unsaved picks. Are you sure you want to discard them?',
      submit: 'Discard',
      cancel: 'Cancel',
    },
    missingBestPickSaveModal: {
      title: 'No best pick',
      description:
        'You have not selected a Best Pick. Are you sure you want to save your picks withou a Best Pick?',
      submit: 'Save picks',
      cancel: 'Continue making picks',
    },
    incompletePicksSaveModal: {
      title: 'Missing picks',
      description:
        'Some games are missing picks. Be sure to make all of your picks before the pick deadline.',
      submit: 'Save picks',
      cancel: 'Continue making picks',
    },
    spreadNotSet: {
      title: 'Spread not set',
      description:
        'You have selected a team where the spread has not been set. Are you sure you want to save your picks? When the spread is set, your pick will not change.',
      submit: 'Save picks',
      cancel: 'Cancel',
    },
    withdrawEntryModal: {
      title: 'Are you sure you want to withdraw this entry ?',
      description: 'By withdrawing your entry the entry fee will be credited back to your account.',
      submit: 'Withdraw',
      cancel: 'Cancel',
      error: {
        title: 'Unable to make a withdrawal to this entry.',
        message: 'Please try again.',
      },
      success: {
        message: 'Withdrawal was successfull.',
      },
    },
    withdrawEOEntryModal: {
      title: 'Are you sure you want to withdraw this entry ?',
      description:
        'By withdrawing your entry, your entry will no longer be eligible to compete in this contest.',
      submit: 'Withdraw',
      cancel: 'Cancel',
      error: {
        title: 'Unable to make a withdrawal to this entry.',
        message: 'Please try again.',
      },
      success: {
        message: 'Withdrawal was successfull.',
      },
    },
    clearAllPicksModal: {
      title: 'Clear all picks',
      description: 'Are you sure you want to clear all of your picks?',
      submit: 'Clear',
      cancel: 'Cancel',
    },
    postPickModal: {
      missingPicks: {
        title: 'You’re not done!',
        subtitle: 'You’ve made {{picksCount}}/{{expectedPicksCount}} picks for this slate',
      },
      title__hasPlural: {
        one: "You've made your pick!",
        other: "You've made your picks!",
      },
      addNewEntries: 'Add new entries',
      viewMyEntries: 'Back to my entries',
      viewEntrantEntries: 'Back to entries',
      makeTheRestOfPicks: 'Make the rest of my picks',
      continueMakingPicks: 'Keep making picks',
      tiebreakerPrediction: 'Tiebreaker prediction: {{value}} points',
    },
    maxPicksForSlateReachedModal: {
      title: 'Max picks for this slate reached',
      description:
        "You have all of your picks made for this slate. If you'd like to change your picks you must remove them.",
      cancel: 'OK',
    },
    gamecenterAutoPickEditSheet: {
      editTitle: 'Edit your auto-pick logic',
      addTitle: 'Set your auto-pick logic',
      addDescription:
        'You must select how you want your auto-picks assigned. You can change this setting at any time by tapping the 3-dot icon in the top nav.',
      editDescription:
        'Change how your auto-picks are assigned. Please note that this change impacts all of your entries in this contest',
      save: 'Save changes',
      error: {
        title: 'Error',
        message: 'Failed to save auto-pick strategy',
      },
    },
  },
  marketplace: {
    banner: {
      title: 'Go to Entry Marketplace',
      subtitle: 'Browse listings, offers, and your entries',
    },
    panels: {
      entries: 'My Entries',
      offers: 'Offers',
    },
    offerSettings: 'Offer settings',
    error: {
      title: 'We could not load this',
      body: 'Something went wrong on our side. Try again in a moment.',
      retry: 'Try again',
    },
    entries: {
      entryFallback: 'Entry {{number}}',
      entryOrdinal: '({{number}})',
      entryUnknown: 'Entry',
      owned: 'Own {{share}}',
      notListed: 'Not listed',
      listings__hasPlural: {
        one: '{{count}} listing',
        other: '{{count}} listings',
      },
      empty: {
        title: 'No entries',
        body: "You don't have any entries in this contest.",
      },
    },
    offers: {
      sections: {
        pending: 'Pending',
        countered: 'Countered',
        closed: 'Closed',
      },
      from: 'From {{handle}}',
      to: 'To {{handle}}',
      share: '{{share}} share',
      viewOffer: 'View offer',
      viewCounter: 'View counter',
      editCounter: 'Edit counter',
      withdrawCounter: 'Withdraw counter',
      waitingForResponse: 'Waiting for response',
      countered: 'Countered',
      counteredFrom: 'Countered from {{handle}}',
      counteredTo: 'Countered to {{handle}}',
      theyOffered: '{{handle}} offered {{amount}} for {{share}}',
      youListed: 'You listed {{amount}} for {{share}}',
      youOffered: 'You offered {{amount}} for {{share}}',
      theyCountered: '{{handle}} countered at {{amount}} for {{share}}',
      youCountered: 'You countered at {{amount}} for {{share}}',
      expires: 'Expires: {{date}}',
      closedMeta: 'From {{handle}} · {{amount}} · {{share}}',
      closedMetaSent: 'To {{handle}} · {{amount}} · {{share}}',
      accepted: 'Accepted',
      declined: 'Declined',
      expired: 'Expired',
      cancelled: 'Cancelled',
      failed: 'Failed',
      closed: 'Closed',
      empty: {
        title: 'No offers yet',
        body: "Offers you make and offers on your entries both show up here. You'll get a notification the moment one comes in.",
      },
    },
  },
  layoutNonScheduled: {
    nav: {
      entries: 'My entries',
      standings: 'Standings',
      stats: 'Stats',
      detail: 'Details',
      availability: 'Availability',
      players: 'Players',
      marketplace: 'Marketplace',
    },
  },
  layoutScheduled: {
    nav: {
      entries: 'Entries',
      entrants: 'Entrants',
      detail: 'Details',
    },
  },
  editSettingsModal: {
    title: 'Contest settings changed',
    description:
      'The commissioner has changed the following settings of this contest. If you would like to withdraw, you can do so on the Entry Details screen.',
  },
  editNameEditModal: {
    title: 'Edit entry name',
    field: 'Entry name',
    submit: 'Save',
    errors: {
      min: "Entry name can't be empty",
      max: "Entry name can't be longer than 30 characters",
      regex: 'Only letters, numbers, hyphen, accented characters and spaces are allowed',
    },
  },
  promotions: {
    gameCenterRAFcallout: {
      title: 'Earn referral bonuses and sweeten the pot by inviting friends now!',
      cta: 'Invite Friends',
    },
  },
  tiebreaker: {
    label: 'TIEBREAKER',
    title: 'Pick the total points scored',
    description:
      "Enter the total points you think will be scored in the championship game. Closest guess wins if there's a tie.",
    slateDescription:
      'Enter the total points you think will be scored in the last game of the week. Closest guess wins if there is a tie.',
    inputLabel: 'Total points guess',
    placeholder: 'Enter a number between {{min}} and {{max}}',
    totalPoints: 'TOTAL POINTS',
    exactMatch: 'Exact!',
    offBy: 'Off by {{diff}}',
    finalResultTooltip: 'Final result: {{total}} total points',
    validation: {
      required: 'Tiebreaker prediction is required',
      min: 'Value must be at least {{min}}',
      max: 'Value must be at most {{max}}',
    },
  },
  bulkCSV: {
    banner: {
      title: 'Edit multiple entries with a CSV file.',
      cta: 'Edit entries',
      lastUpload: 'Last upload: {{date}}',
      viewCta: 'View',
    },
    modal: {
      editing: {
        title: 'Edit multiple entries',
        slateSelect: {
          label: 'Select slate',
        },
        uploadCta: 'Upload CSV for {{slateName}}',
        step1: {
          titleHasNotPrevUploaded: '1. Download a template',
          titleHasPrevUploaded: '1. Download your CSV file to edit',
          descriptionHasNotPrevUploaded: 'Download the template for this contest.',
          descriptionHasPrevUploaded:
            'Download the CSV file you previously uploaded to edit your entries.',
          ctaHasNotPrevUploaded: 'Download CSV template for {{slateName}}',
          ctaHasPrevUploaded: 'Download your CSV file for {{slateName}}',
        },
        step2: {
          titleHasNotPrevUploaded: '2. Fill out the template',
          titleHasPrevUploaded: '2. Edit your entries',
          descriptionHasNotPrevUploaded:
            'Follow the instructions in the template to edit your entries.',
          descriptionHasPrevUploaded: 'Edit your entries in the CSV file.',
        },
        step3: {
          title: '3. Save and upload',
          description: 'Once finished editing, save the file and select it for upload.',
        },
        cta: {
          continue: 'Continue',
        },
      },
      uploading: {
        title: 'Uploading CSV',
        content: 'Uploading entries...',
      },
      uploadSuccess: {
        title: 'Success',
        content: 'Your CSV file was successfully uploaded.',
        cta: 'View results',
      },
      uploadError: {
        title: 'We couldn’t process your CSV file',
        content:
          'Please check that your file is properly formatted and contains valid data, then try uploading again. If you continue to have issues, please contact support for assistance.',
        closeCta: 'Close',
        editCta: 'Go back and edit',
      },
      results: {
        title: 'Results',
        savedTitle: 'Entries saved for {{slateName}}',
        successCountSuffix: 'entries were successfully edited',
        errorsIntroSuffix: 'entries returned errors and are listed below',
        doneCta: 'Done',
        editCta: 'Go back and edit',
        loading: 'Loading results',
      },
    },
  },
  standingsExport: {
    banner: {
      title: 'Export standings into a CSV file.',
      cta: 'Export',
    },
    modal: {
      title: 'Download all picks (CSV)',
      description: 'Export every entry’s picks in this contest as a csv file.',
      info: 'The CSV reflects the most recently finalized slate. Shortly after the last game in the slate goes final the download will update with the picks from that slate and include picks for all prior finalized slates.',
      downloadCta: 'Download CSV',
      closeCta: 'Close',
    },
  },
};
